<form [formGroup]="form">
  <!--- Installationsdetaljer --->
  <app-guide-card
    [fullWidth]="fullWidth"
    [valid]="(form.get('detailCharacteristics.productCharacteristicIdentification')?.valid || form.get('detailCharacteristics.productCharacteristicIdentification')?.disabled) &&
     (form.get('detailCharacteristics.productCharacteristicUnitType')?.valid || form.get('detailCharacteristics.productCharacteristicUnitType')?.disabled)  &&
     (form.get('detailCharacteristics.disconnectionType')?.valid || form.get('detailCharacteristics.disconnectionType')?.disabled) &&
     (form.get('detailCharacteristics.maximumPower')?.valid || form.get('detailCharacteristics.maximumPower')?.disabled) &&
     (form.get('detailCharacteristics.maximumCurrent')?.valid || form.get('detailCharacteristics.maximumCurrent')?.disabled) ">
    <div title>
      {{ 'meteringPoint.create.installationDetails.title' | translate }}
    </div>
    <div description>
      {{ 'meteringPoint.create.installationDetails.description' | translate }}
    </div>
    <div>
      <fieldset formGroupName="detailCharacteristics">
        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.productCharacteristicIdentification' | translate }}</label>
          <select appSelect [collection]="productList" formControlName="productCharacteristicIdentification"></select>
        </app-input-group>


        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.unitType' | translate }}</label>
          <select appSelect [collection]="unitTypeList" formControlName="productCharacteristicUnitType"></select>
        </app-input-group>

        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.disconnectionType' | translate }}</label>
          <select appSelect [collection]="disconnectionTypeList" formControlName="disconnectionType"></select>
        </app-input-group>

        <div class="bg-slate-100 dark:bg-dark-border w-full h-[1px] mt-6 mb-4"></div>

        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.maximumPower' | translate }}</label>
          <input appInput formControlName="maximumPower" type="number" append="kW" [placeholder]="'meteringPoint.create.maximumPower'| translate">
        </app-input-group>

        <app-input-group [hideDisabled]="true">
          <label appLabel>{{ 'meteringPoint.create.maximumCurrent' | translate }}</label>
          <input appInput formControlName="maximumCurrent" type="number" append="A" [placeholder]="'meteringPoint.create.maximumCurrent' | translate">
        </app-input-group>

      </fieldset>
    </div>
  </app-guide-card>
</form>
